var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSoundWaveIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2961_54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.9285 14.9998H22.5C22.0085 14.9998 21.5801 15.3342 21.4607 15.8109L19.6746 22.9541L17.1353 0.948012C17.067 0.360213 16.5351 -0.0608458 15.9473 0.00752048C15.4876 0.0610082 15.1142 0.40353 15.0214 0.85692L11.626 17.8391L9.60531 10.4323C9.45056 9.86118 8.86207 9.52368 8.29097 9.67843C7.96571 9.76657 7.70091 10.0026 7.57604 10.3155L5.70322 14.9998H1.07145C0.479694 14.9998 0 15.4795 0 16.0712C0 16.6629 0.479694 17.1427 1.07145 17.1427H6.42857C6.86702 17.1429 7.26127 16.8759 7.42393 16.4687L8.37854 14.0805L10.7518 22.7815C10.8789 23.2478 11.3024 23.5713 11.7857 23.5712H11.8221C12.3175 23.5543 12.7368 23.1998 12.8357 22.714L15.7864 7.95515L18.2217 29.0505C18.2807 29.5651 18.6992 29.9638 19.216 29.9977L19.2856 29.9998C19.777 29.9992 20.205 29.6644 20.3239 29.1876L23.3368 17.1427H28.9285C29.5203 17.1427 30 16.663 30 16.0712C30 15.4795 29.5203 14.9998 28.9285 14.9998Z",
    fill: "#00A751"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2961_54"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundWaveIcon);
export default __webpack_public_path__ + "static/media/soundWaveIcon.5c724152660c11c6f5e8ca3afadf1d3c.svg";
export { ForwardRef as ReactComponent };